import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicWhyHostInfoBlock && values.dynamicWhyHostInfoBlock.length > 0) {
    const dynamicWhyHostInfoBlockErrors = [];
    values.dynamicWhyHostInfoBlock.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.peaceTitleHeading) {
        itemErrors.peaceTitleHeading = messages.required;
      } else if (item.peaceTitleHeading.trim() == "") {
        itemErrors.peaceTitleHeading = messages.required;
      } else if (item.peaceTitleHeading && item?.peaceTitleHeading?.length > inputTextLimit) {
        itemErrors.peaceTitleHeading = messages.inputTextLimitError;
      }

      if (!item.peaceTitle3) {
        itemErrors.peaceTitle3 = messages.required;
      } else if (item.peaceTitle3.trim() == "") {
        itemErrors.peaceTitle3 = messages.required;
      } else if (item.peaceTitle3 && item?.peaceTitle3?.length > inputTextLimit) {
        itemErrors.peaceTitle3 = messages.inputTextLimitError;
      }

      if (!item.peaceContent3) {
        itemErrors.peaceContent3 = messages.required;
      } else if (item.peaceContent3.trim() == "") {
        itemErrors.peaceContent3 = messages.required;
      } else if (item.peaceContent3 && item?.peaceContent3?.length > inputDescLimit) {
        itemErrors.peaceContent3 = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicWhyHostInfoBlockErrors[index] = itemErrors;
      }
    });

    if (dynamicWhyHostInfoBlockErrors.length > 0) {
      errors.dynamicWhyHostInfoBlock = dynamicWhyHostInfoBlockErrors;
    }
  }

  return errors
}

export default validate;